import React, { useState } from 'react';

interface HomePageProps {
    onCreateRoom: (playerName: string, roomName: string) => void;
    onJoinRoom: (playerName: string, roomCode: string) => void;
    isLoading: boolean;
}

export const HomePage: React.FC<HomePageProps> = ({ onCreateRoom, onJoinRoom, isLoading }) => {
    const [view, setView] = useState<'main' | 'create' | 'join'>('main');
    const [playerName, setPlayerName] = useState('');
    const [roomName, setRoomName] = useState('');
    const [roomCode, setRoomCode] = useState('');

    const handleCreate = () => {
        if (playerName && roomName) {
            onCreateRoom(playerName, roomName);
        }
    };

    const handleJoin = () => {
        if (playerName && roomCode) {
            onJoinRoom(playerName, roomCode.toUpperCase());
        }
    };

    const renderMain = () => (
        <div className="home-actions-vertical">
            <button className="pixel-button" onClick={() => setView('create')}>建立房間</button>
            <button className="pixel-button" onClick={() => setView('join')}>加入房間</button>
        </div>
    );

    const renderCreate = () => {
        if (isLoading) {
            return <h4>建立中...</h4>;
        }
        return (
            <div className="home-form-vertical">
                <h2>建立房間</h2>
                <input 
                    className="pixel-input" 
                    placeholder="你的名字" 
                    value={playerName} 
                    onChange={(e) => setPlayerName(e.target.value)} 
                    maxLength={12}
                />
                <input 
                    className="pixel-input" 
                    placeholder="房間名稱" 
                    value={roomName} 
                    onChange={(e) => setRoomName(e.target.value)} 
                    maxLength={20}
                />
                <div className="home-actions-horizontal">
                    <button className="pixel-button" onClick={handleCreate}>建立</button>
                    <button className="pixel-button" onClick={() => setView('main')}>返回</button>
                </div>
            </div>
        );
    };

    const renderJoin = () => {
        if (isLoading) {
            return <h4>加入中...</h4>;
        }
        return (
            <div className="home-form-vertical">
                <h2>加入房間</h2>
                <input 
                    className="pixel-input" 
                    placeholder="你的名字" 
                    value={playerName} 
                    onChange={(e) => setPlayerName(e.target.value)} 
                    maxLength={12}
                />
                <input 
                    className="pixel-input" 
                    placeholder="六位數房號" 
                    value={roomCode}
                    onChange={(e) => setRoomCode(e.target.value.replace(/[^0-9]/g, ''))} 
                    maxLength={6}
                    type="tel"
                    pattern="[0-9]*"
                />
                <div className="home-actions-horizontal">
                    <button className="pixel-button" onClick={handleJoin}>加入</button>
                    <button className="pixel-button" onClick={() => setView('main')}>返回</button>
                </div>
            </div>
        );
    };

    switch (view) {
        case 'create': return renderCreate();
        case 'join': return renderJoin();
        default: return renderMain();
    }
};